import type {SalesRepository} from '../repository/SalesRepository';
import type {BaseResponse} from '../../../Data/types/BaseResponse';
import type {SalesStatistics} from '../models/sale.model';

export class GetSalesStatisticsUseCase {
  constructor (private salesRepository: SalesRepository) {}

  async execute (): Promise<BaseResponse<SalesStatistics>> {
    return await this.salesRepository.getSalesStatistics();
  }
}
